import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { loadFromLink } from 'Components/Accounts/AccountActions';
import {
  useAccountStateContext,
  useAccountDispatchContext,
} from 'Components/Accounts/AccountContext';
import PlannerDataTabAccountOverride from 'Overrides/PlannerDataTabAccount';
import InvestmentsView from './InvestmentsView';

const InvestmentsRoot = (props) => {
  const { householdResource } = useSimpleHousehold();
  const state = useAccountStateContext();
  const dispatch = useAccountDispatchContext();
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'MissionControl > Planner Data Tab > Investments',
  });

  React.useEffect(() => {
    const accountRelationship = householdResource
      .relationship('accountsReadonly')
      ?.link('related');
    if (!state.loading && !state.accountCollection && accountRelationship) {
      loadFromLink(accountRelationship, dispatch, state, PlannerDataTabAccountOverride);
    }
  }, []);

  return <InvestmentsView {...props} {...rootNodeProps} />;
};

export default InvestmentsRoot;
